<template>
  <div v-if="data" class="complete-product-wrapper">
    <vs-checkbox
      @change="onProductCheckChange($event)"
      :name="data.id"
      class="complete-product">{{data.name}} - ${{formatPrice(price)}}
    </vs-checkbox>
    <div v-if="selectedLocal" class="complete-product-description">
      <component :is="scrollbarTag" data-vv-scope="product-info" class="product-info scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

        <div class="padding-spacer">
          <!-- NAME -->

          <h5 label="Name" name="item-name" >{{data.name}}</h5>
        </div>
        <div class="padding-spacer" v-if="data.description != null">
          <!-- NAME -->

          <p name="item-name" >{{data.description}}</p>
        </div>
        <div >
          <div v-if="size_complete  !== null" class="padding-spacer size-item modifier required" >
            <label class="vs-input--label">{{ size_complete.instructions }}</label>

            <div class="w-full">
              <vs-radio v-model="sizeRadioValueObject"
                        :vs-value="size_item.id"
                        v-for="size_item in size_complete.items"
                        :key="size_item.id"
                        class="mr-4 w-full"
                        vs-name="size-complete">{{ size_item.name }} - ${{ formatPrice(size_item.price) }}</vs-radio>

            </div>
            <span class="text-danger text-sm"
                  v-show="errors.has('size')">{{ errors.first('size') }}</span>
          </div>
          <div v-if="hasModifiers.length > 0" v-for="(modifier, index) in hasModifiers"  class="modifier padding-spacer size-item" :class="(modifier.modifier.required_choice === 1) ? 'required' : ''" v-bind:key="index" >
            <label class="vs-input--label">{{modifier.modifier.instructions}}</label>
            <div v-if="modifier.modifier.how_many_choices === 2">
              <vs-checkbox
                v-bind:key="check_item.id"
                v-for="(check_item, check_item_index) in modifier.modifier.items"
                @change="onModifierCheckChange(modifier,index, check_item_index, $event)"
                :name="'mod'.concat(check_item.id)"
                v-validate="(modifier.modifier.required_choice === 1 && Array.isArray(modifier.modifier.selected_value)) ? 'required' : ''"
                class="">{{(check_item.price !== 0) ? `${check_item.name} - $${formatPrice(check_item.price)}` : check_item.name}}</vs-checkbox>
            </div>

            <div v-else-if="modifier.modifier.how_many_choices === 3"
                 v-bind:key="check_item.id" v-for="(check_item, check_item_index) in modifier.modifier.items">
              <vs-checkbox
                @change="onModifierCheckChange(modifier,index, check_item_index, $event)"
                :name="'mod'.concat(modifier.id)"
                v-validate="(modifier.modifier.required_choice === 1 && Array.isArray(modifier.modifier.selected_value)) ? 'required' : ''"
                class="">{{(check_item.price !== 0) ? `${check_item.name} - $${formatPrice(check_item.price)}` : check_item.name}}</vs-checkbox>
            </div>
            <div v-else
                 v-bind:key="check_item.id" v-for="(check_item, check_item_index) in modifier.modifier.items">
              <vs-checkbox
                @change="onModifierCheckChange(modifier,index, check_item_index, $event)"
                :ref="'mod'.concat(check_item.id)"
                v-validate="isModifierRequired(modifier)"
                class="">{{(check_item.price !== 0) ? `${check_item.name} - $${formatPrice(check_item.price)}` : check_item.name}}</vs-checkbox>
            </div>
            <span class="text-danger text-sm"
                  v-show="errors.has('mod'.concat(modifier.id))">{{ String(errors.first('mod'.concat(modifier.id))).replace('mod'.concat(modifier.id), modifier.modifier.name) }}</span>
          </div>

        </div>
      </component>

    </div>
  </div>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
export default {
  props: {
    data: {
      type: Object,
      required:  true
    },
    checkChange: {
      type: Function
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect
  },
  mounted () {
    this.loadData()
  },
  data () {
    return {
      //todo: addproductsidebar ve completeproduct size objeleri birbirine karışıyor.
      sizeRadioValueObject: 0,
      restaurantId: null,
      productId: null,
      name: '',
      description: '',
      sizeType: 'single',
      sizeId: null,
      size_complete: null,
      price: 0,
      basePrice: 0,
      section: null,
      sectionId: null,
      progress: 0,
      complete_your_meal_products: null,
      selected_complete_your_meal_products: [],
      hasModifiers: {
        type: Array
      },
      mobile:window.innerWidth <= 700,
      size_selected_value: null,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      cart_product: {},
      selectedLocal: false
    }
  },
  watch: {
    selectedLocal (val) {
      this.sendProductData()
      if (!val) {
        this.resetData()
      }
    },
    sizeRadioValueObject (val) {
      const size_val = this.getSizeOptionsForSelect(this.size_complete)[val]
      this.size_complete.selected_value = size_val
      this.size_selected_value = size_val
      this.handlePriceChange()
    }
  },
  computed: {
    scrollbarTag () {
      return this.$store.getters.scrollbarTag
    }
  },
  name: 'CompleteProduct',
  methods: {
    sendProductData () {
      const cartObject = JSON.parse(JSON.stringify(this.data))
      cartObject.modifiers = this.hasModifiers
      cartObject.hasModifiers = this.hasModifiers
      cartObject.size = this.size_complete
      cartObject.totalPrice = this.price

      this.checkChange(this.selectedLocal, cartObject)
    },
    resetData () {
      this.name = ''
      this.description = ''
      if (Array.isArray(this.hasModifiers)) {
        this.hasModifiers.forEach(function (key) {
          key.modifier.selected_value = null
        })
      }
      if (this.size !== null) {
        this.size_selected_value = null//{label: 'Please select a size', value: 0, price: '0'}
      }
      this.hasModifiers = []
      this.size = null
    },
    loadData () {
      const {name, id, price, description, restaurant_id, size, section, size_id, section_id, hasModifiers, photoUrl} = JSON.parse(JSON.stringify(this.data))
      this.productId = id
      this.name = name
      this.price = price
      this.basePrice = price
      this.description = description
      this.restaurantId = restaurant_id
      this.hasModifiers = hasModifiers
      this.section = section
      this.sizeId = size_id
      this.sectionId = section_id
      this.dataImg = photoUrl

      if (size !== null) {
        this.size_complete = size
        if (price === 0) {
          this.sizeType = 'multiple'
        }
        this.price = size.items[0].price
        this.size_selected_value = this.getSizeOptionsForSelect(this.size_complete)[this.size_complete.items[0].id]
        this.sizeRadioValueObject = this.size_selected_value.value

      }
    },
    handlePriceChange () {
      const self = this
      if (this.size_complete) {
        this.price = this.size_selected_value.price
      } else {
        this.price = this.basePrice
      }
      this.hasModifiers.forEach(function (key) {
        if (typeof key.modifier.selected_value !== 'undefined' || key.modifier.selected_value !== null) {
          if (Array.isArray(key.modifier.selected_value)) {
            key.modifier.selected_value.forEach(function (item) {
              self.price = Number(self.price) + Number(item.price)
            })
          } else if (key.modifier.selected_value) {
            self.price = Number(self.price) + Number(key.modifier.selected_value.price)
          }
        }
      })

      this.price = self.price
      this.sendProductData()
    },
    formatPrice (value) {
      const val = (value / 1).toFixed(2)
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    getSizeOptionsForSelect (size) {
      const list = size.items
      const opt_list = []
      if (list !== 'undefined') {
        list.forEach(function (key) {

          let name = key.name
          if (key.price !== '0') {
            name = name.concat(' - $').concat(key.price)
          }
          opt_list[key.id] = {label: name, value: key.id, price: key.price}
        })
      }

      return opt_list
    },
    getModifierOptionsForSelect (modifier) {
      const list = modifier.items
      let opt_list = []
      if (list !== 'undefined') {
        list.forEach(function (key) {
          const key_id = key.id
          let name = key.name
          if (key.price !== '0') {
            name = name.concat(' - $').concat(key.price)
          }
          opt_list[String(key_id)] = {label: name, value: key.id, price: key.price}
        })
      }

      if (modifier.how_many_choices !== 1 && Array.isArray(modifier.selected_value)) {
        if (modifier.how_many_choices !== 3 && modifier.max_choice === modifier.selected_value.length) {
          opt_list = []
        }
      }

      return opt_list
    },
    onModifierCheckChange (mod, index, mod_item_index, e) {

      const modifier = mod.modifier

      if (modifier.how_many_choices === 4) {

        if (e.target.checked) {
          if (!modifier.selected_value) {
            modifier.selected_value = []
          }
          if (modifier.max_choice > modifier.selected_value.length) {
            modifier.selected_value.push({
              label: modifier.items[mod_item_index].name,
              value: modifier.items[mod_item_index].id,
              price: modifier.items[mod_item_index].price
            })
          } else {
            e.target.checked = false
            this.$vs.notify({
              title: 'Max item reached',
              text: 'You have reached the max limit for this item',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          }
        } else if (modifier.selected_value) {
          const remove_index = modifier.selected_value.find(x => x.value === modifier.items[mod_item_index].id)
          modifier.selected_value.splice(remove_index, 1)
        }
      } else if (modifier.how_many_choices === 3) {
        if (e.target.checked) {
          if (!modifier.selected_value) {
            modifier.selected_value = []
          }
          modifier.selected_value.push({
            label: modifier.items[mod_item_index].name,
            value: modifier.items[mod_item_index].id,
            price: modifier.items[mod_item_index].price
          })

        } else if (modifier.selected_value) {
          const remove_index = modifier.selected_value.find(x => x.value === modifier.items[mod_item_index].id)
          modifier.selected_value.splice(remove_index, 1)
        }
      } else if (modifier.how_many_choices === 2) {
        if (e.target.checked) {
          if (modifier.selected_value) {
            e.target.checked = false
            this.$vs.notify({
              title: 'Max item reached',
              text: 'You have reached the max limit for this item',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning'
            })
          } else {
            modifier.selected_value = {
              label: modifier.items[mod_item_index].name,
              value: modifier.items[mod_item_index].id,
              price: modifier.items[mod_item_index].price
            }
          }
        } else if (modifier.selected_value) {
          modifier.selected_value = null
        }
      }


      mod.modifier = modifier
      this.hasModifiers[index] = mod

      this.handlePriceChange()
    },
    onModifierChange (mod, index, e) {
      const modifier = mod.modifier
      if (modifier.how_many_choices === 2) {
        //modifier.selected_value = e
        modifier.selected_value = e
      }
      mod.modifier = modifier
      this.hasModifiers[index] = mod

      this.handlePriceChange()
    },
    onSizeChange (size, e) {
      size.selected_value = e
      this.handlePriceChange()
    },
    isModifierRequired (modifier) {
      let result = ''
      if (modifier.modifier.required_choice === 1) {
        if (Array.isArray(modifier.modifier.selected_value)) {
          if (modifier.modifier.selected_value.length < modifier.modifier.min_choice) {
            result = 'required'
          }
        } else {
          result = 'required'
        }

      }
      return result
    },
    onProductCheckChange () {
      this.selectedLocal = !this.selectedLocal
    }
  }
}
</script>

<style lang="scss">
.complete-product-wrapper {
  margin-bottom: 25px;
  padding: 5px;
  background-color: #f2f2f2;
}
.complete-product{
  margin-bottom: 0px;
}
.complete-product-description{
  .padding-spacer{
    margin:15px 0;
  }
  .vs-input--label{
    font-weight:bold;
  }
}
</style>
